module.exports = __webpack_public_path__ + "media/effects-16.bf928d7f.webm";